module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"header":"Identifisering","expired":"Økten har utløpt. Lukk nettleser og forsøk igjen."},"en":{"header":"Identification","expired":"This session has expired. Please close this browser window and try again."}}')
  delete Component.options._Ctor
}
